import React from 'react';
import './navbar.css';
import logo from './logo.png';
import { LinkNewTab } from './LinkNewTab'; // import LinkNewTab here

function Navbar({ handleModalOpen }) {
  const openAboutPage = () => {
    window.open('/about', '_blank', 'width=800,height=600');
  };

  return (
    <div className="navbar">
      <h1>Urban Video Archive 0.14</h1>
      <img src={logo} className='navbar-logo' />
      <button className='navbar-button' onClick={() => handleModalOpen('about')}>About</button>
      <button className='navbar-button' onClick={() => handleModalOpen('instructions')}>Instructions</button>
    </div>
  );
};

export default Navbar;
